import moment from 'moment';
import { FaClock } from "react-icons/fa";
import CircleIcon from 'components/CircleIcon';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';

export default function NextPaymentDates({nextDepositDate, balanceDueDate, depositLate}) {
  const { whiteLabelSettings = {} } = useWhiteLabelSettings();
  const { primaryColour } = whiteLabelSettings;
  const dateFormat = 'DD/MM/YYYY';
  
  return (
    <div className="flex flex-col md:flex-row md:border-t">
      {nextDepositDate && (
        <div className="flex flex-col mt-12 md:m-6 md:pr-6 md:border-r">
          <div>Next deposit due</div>
          <p className={`flex items-center absolute mt-6 text-lg font-bold
            ${depositLate && `text-red-500`}
          `}>
            <CircleIcon
              className="mr-2"
              iconPadding="11px"
              iconClassName="text-sm"
            >
              <FaClock style={{ fill: primaryColour }} />
            </CircleIcon>
            {moment(nextDepositDate).format(dateFormat)}
          </p>
        </div>
      )}
      <div className={`flex flex-col mt-12
        ${nextDepositDate ? `md:my-6 md:mr-6` : `md:m-6`}
      `}>
        {balanceDueDate &&
          <>
            <div>Full amount due</div>
            <div className="text-lg font-bold">{moment(balanceDueDate).format(dateFormat)}</div>
          </>
        }
      </div>
    </div>
  );
}
